import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import * as R from 'ramda';


const KEY_ACTION = ActionType.SecurityQuestionKeysRequest;
const ACTIONS    = [
  ActionType.SecurityQuestionKeysRequest,
  ActionType.SecurityQuestionKeysResponse,
  ActionType.SecurityQuestionKeysError,
];


type SecurityQuestionKey = {
  key: string;
  questionId: number;
}


type Payload = SecurityQuestionKey[];


/**
 * Dispatch this action to retrieve the user's security question (which they will have to answer in order to reset
 * their password)
 * @param emailAddress - the email address of the user whose security question we need to retrieve
 */
export const securityQuestionKeysAction = makeApiAction<Payload>({
  method:   'POST',
  endpoint: Endpoints.SecurityQuestionKeys,
  headers:  { 'content-type': 'application/json' },
  types:    makeRsaaTypes<Payload>(ACTIONS),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'securityQuestionKeys'], payload, successState);
};


export const securityQuestionKeysReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
